// Webpacker requires
// https://github.com/rails/webpacker#usage
import 'regenerator-runtime/runtime'

// Rails
import RailsUjs from 'rails-ujs';

// Stimulus controllers
import "../../javascripts/controllers/index";

// Images
require.context('../../images', true)

// Fonts
require.context('../../fonts', true)

RailsUjs.start()

window.jQuery = jQuery

// -------------------------------------------------------------------------------------------------
import 'bootstrap/dist/js/bootstrap.bundle'
